<celum-avatar class="user-avatar" [configuration]="config()"></celum-avatar>
